import React, { useState } from "react";
import Calendar from "../components/Calendar";
import NewMeetingForm from "../components/NewMeetingForm";
import UpcomingMeetingsList from "../components/UpcomingMeetingsList";
import { selectCurrentUser } from "../../../store/slices/authSlice";
import { useSelector } from "react-redux";

const Dashboard: React.FC = () => {
  const [showNewMeetingForm, setShowNewMeetingForm] = useState(false);
  const openNewMeetingForm = () => setShowNewMeetingForm(true);
  const closeNewMeetingForm = () => setShowNewMeetingForm(false);

  const currentUser = useSelector(selectCurrentUser);
  const mentorId = currentUser?.id || "";
  return (
    <div className="  w-[1200px] mx-auto">
      <div className="w-full max-w-[1440px] mx-auto flex gap-6 px-6 mt-6">
        <div className="w-[400px] shrink-0">
          <UpcomingMeetingsList mentorId={mentorId} />
        </div>

        <div className="flex-1 flex flex-col items-center">
          <Calendar />
          <button
            onClick={openNewMeetingForm}
            className="mt-6 bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-xl shadow-md transition focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            פגישה חדשה
          </button>
        </div>
      </div>

      {showNewMeetingForm && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={closeNewMeetingForm}
        >
          <div
            className="bg-white rounded-lg p-6 shadow-lg max-w-md w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="mb-4 text-right w-full text-gray-600 hover:text-gray-900"
              onClick={closeNewMeetingForm}
            >
              ✕ סגור
            </button>

            <NewMeetingForm onClose={closeNewMeetingForm} />
          </div>
        </div>
      )}
    </div>
  );
};
export default Dashboard;